<div class="text-center">
  <fgb-loading></fgb-loading>
</div>
